import {
  GET_SMALLER_COMPANIES_PARTICIPATION,
  GET_SMALLER_COMPANIES_PARTICIPATION_SUCCESS,
  GET_SMALLER_COMPANIES_PARTICIPATION_ERROR
} from './SmallerCompaniesParticipation.actions'

const initialState = {
  data: [],
  series: [],
  csv: [],
  loading: false,
  error: null
}

/**
 * The smaller Companies Participation's reducer.
 */
const smallerCompaniesParticipationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SMALLER_COMPANIES_PARTICIPATION:
      return { ...state, loading: true }
    case GET_SMALLER_COMPANIES_PARTICIPATION_SUCCESS:
      return { ...state, loading: false, data: payload.data, series: payload.series, csv: payload.csv }
    case GET_SMALLER_COMPANIES_PARTICIPATION_ERROR:
      return { ...state, loading: false, error: payload, data: [], series: [], csv: [] }
    default:
      return state
  }
}

export default smallerCompaniesParticipationReducer
